import React, { Component } from 'react'
import "../../css/general-style.css"
import '../../css/table-responsive.css'
import { NumberFormat } from '../../functions/generalFunctions';
import { pricesFormat } from '../../functions/pricesFormat';
import { AiFillCaretLeft, AiFillCaretRight } from 'react-icons/ai'
import PieGraph from '../PieGraph';
import DashModalV2 from '../DashModalV2';
import { getValueCookie } from '../../services/cookieService';


export default class extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();

    }
    state = {
        Title: '',
        showModal1: false,
        Detail: [],
        Total: 0

    }
    clearStates() {
        this.setState({
            Detail: [],
            Title: '',
            Total: 0
        })
    }

    handleModalOpen = (modal) => {

        this.setState({ [modal]: true })
    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false })
        this.clearStates()
    }
    getTotals() {
        let total = 0
        for (const row of this.state.Detail) {
            total += row.NonTaxableSalesAmt
        }
        this.setState({ Total: total })
    }

    async getDetail(detail, title) {
        await this.setState({ Detail: detail.sort((a, b) => b.NonTaxableSalesAmt - a.NonTaxableSalesAmt), Title: title })
        await this.getTotals()
        await this.handleModalOpen("showModal1")
    }
    addMonth() {
        if (getValueCookie('TypeUser') === '1') {
            this.props.Father.changeAllMonthData(this.props.SalesPerson, (this.props.Date.setMonth(this.props.Date.getMonth() + 1)))
        }

    }
    restMonth() {
        if (getValueCookie('TypeUser') === '1') {
            this.props.Father.changeAllMonthData(this.props.SalesPerson, (this.props.Date.setMonth(this.props.Date.getMonth() - 1)))
        }
    }


    render() {
        return (
            <>
                <div className='row'>
                    <div className='col-sm-12'>
                        <h5>{this.props.Title}</h5>
                    </div>
                    <div className='col-sm-12 pb-2'>
                        <div className='pb-3' />
                        {getValueCookie('TypeUser') !== '1' ?
                            <div className='tableFixHeadSmall'>
                                <table className='table table-clean align-middle'>
                                    <thead className='thead'>
                                        <tr className='table-blue-header text-center'>
                                            <th colSpan={7}>{this.props.Month}</th>
                                        </tr>
                                        <tr className='table-blue-header text-center'>
                                            <th>Route Type</th>
                                            <th></th>
                                            <th>Total Sales </th>
                                            <th>Percentage</th>
                                            <th></th>
                                            <th>Goal</th>
                                            <th>Complete Goal Percentage</th>
                                            <th hidden>Total of Sales</th>
                                        </tr>
                                    </thead>
                                    <tbody className='tbody'>
                                        {
                                            this.props.data.Information.map((element, e) => (
                                                <tr onClick={() => this.getDetail(element.Detail, element.Name)} key={e} className={element.Color}>
                                                    <td className=' text-start' >{element.Name}</td>
                                                    {
                                                        element.Data.map((amount, a) => (
                                                            <React.Fragment key={a + 585 + 5}>
                                                                <td className='text-end'>$</td>
                                                                <td className='text-end'>{NumberFormat(pricesFormat(amount.Total))}</td>
                                                                <td className='text-center'>{(pricesFormat(amount.Percentage)) + "%"}</td>
                                                                <td className='text-end'>$</td>
                                                                <td className='text-end'>{NumberFormat(pricesFormat(amount.TotalMeta))}</td>
                                                                <td className='text-center'>{(pricesFormat(amount.PercentageComplete)) + "%"}</td>

                                                            </React.Fragment>
                                                        ))
                                                    }
                                                    <td hidden className=' text-center' >{element.Detail.length}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                    <tfoot className='tfoot'>
                                        <tr className=''>
                                            <td className='text-center '>TOTAL</td>
                                            <React.Fragment>
                                                {this.props.data.Months.map((month, m) => (
                                                    <React.Fragment key={m}>
                                                        <td className='text-end'>$</td>
                                                        <td className='text-end'>{NumberFormat(pricesFormat(month.Total))}</td>
                                                        <td className='text-center'>100%</td>
                                                        <td className='text-end'>$</td>
                                                        <td className='text-end'>{NumberFormat(pricesFormat(month.TotalMeta))}</td>
                                                        <td className='text-center'>{month.TotalMeta > 0 ? NumberFormat(pricesFormat((month.Total / month.TotalMeta) * 100)) + "%" : "0.00%"}</td>

                                                    </React.Fragment>
                                                ))}
                                            </React.Fragment>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            :
                            <div className='tableFixHeadSmall'>
                                <table className='table table-clean align-middle'>
                                    <thead className='thead'>
                                        <tr className='table-blue-header text-center'>
                                            <th colSpan={7}>
                                                <div className='row'>
                                                    <div className='col-2' onClick={() => this.restMonth()}><AiFillCaretLeft /></div>
                                                    <div className='col-8'>{this.props.Month}</div>
                                                    <div className='col-2' onClick={() => this.addMonth()}><AiFillCaretRight /></div>
                                                </div>
                                            </th>
                                        </tr>
                                        <tr className='table-blue-header text-center'>
                                            <th>Route Type</th>
                                            <th></th>
                                            <th>Total Sales </th>
                                            <th>Percentage</th>
                                            <th></th>
                                            <th>Goal</th>
                                            <th>Complete Goal Percentage</th>
                                            <th hidden>Total of Customer</th>
                                        </tr>
                                    </thead>
                                    <tbody className='tbody'>
                                        {
                                            this.props.data.Information.map((element, e) => (
                                                <tr onClick={() => this.getDetail(element.Detail, element.Name)} key={e} className={`${element.Color} text-end`}>
                                                    <td className='text-start' >{element.Name}</td>
                                                    {
                                                        element.Data.map((amount, a) => (
                                                            <React.Fragment key={a + 585 + 5}>
                                                                <td>$</td>
                                                                <td>{NumberFormat(pricesFormat(amount.Total))}</td>
                                                                <td className='text-center'>{(pricesFormat(amount.Percentage)) + "%"}</td>
                                                                <td>$</td>
                                                                <td>{NumberFormat(pricesFormat(amount.TotalMeta))}</td>
                                                                <td className='text-center'>{(pricesFormat(amount.PercentageComplete)) + "%"}</td>

                                                            </React.Fragment>
                                                        ))
                                                    }
                                                    <td hidden className='text-start' >{element.Detail.length}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                    <tfoot className='tfoot'>
                                        <tr className='text-end'>
                                            <td className='text-center'>TOTAL</td>
                                            <React.Fragment>
                                                {this.props.data.Months.map((month, m) => (
                                                    <React.Fragment key={m}>
                                                        <td>$</td>
                                                        <td>{NumberFormat(pricesFormat(month.Total))}</td>
                                                        <td className='text-center'>100%</td>
                                                        <td>$</td>
                                                        <td>{NumberFormat(pricesFormat(month.TotalMeta))}</td>
                                                        <td className='text-center'>{month.TotalMeta > 0 ? NumberFormat(pricesFormat((month.Total / month.TotalMeta) * 100)) + "%" : "0.00%"}</td>

                                                    </React.Fragment>
                                                ))}
                                            </React.Fragment>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        }
                    </div>
                    <div className='col-sm-12 pb-1'>
                        <div className='importantNoteContainer'>
                            <p className='importantNoteText'>* The total sales does not include late invoices, spoilage, discounts and credit notes</p>
                        </div>
                    </div>
                    {
                        this.props.data.Months.map((element, e) => (
                            <div key={e} style={{ display: 'flex', justifyContent: 'center', paddingTop: '8px' }}>
                                <div style={{ width: '80%', maxWidth: '380px' }}>
                                    <PieGraph options={element.Options} data={element.DataSet} />
                                </div>
                            </div>
                        ))
                    }
                </div>
                <DashModalV2
                    title={'Sales: ' + this.state.Title}
                    subtitle={`Total: $${NumberFormat(pricesFormat(this.state.Total))}`}
                    show={this.state.showModal1}
                    onClose={() => this.handleModalClose('showModal1')}
                >
                    <div className="tableFixHeadSmall">
                        <table className='table table-clean align-middle'>
                            <thead>
                                <tr>
                                    <th>Invoice No</th>
                                    <th>Invoice Type</th>
                                    <th>Customer No</th>
                                    <th>Customer Name</th>
                                    <th>Route</th>
                                    <th className='text-end'>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.Detail.map((order, o) => (
                                    <tr key={o}>
                                        <td>{order.InvoiceNo}</td>
                                        <td className='text-center'>{order.InvoiceType}</td>
                                        <td>{order.CustomerNo}</td>
                                        <td>{order.BillToName}</td>
                                        <td>{order.UDF_RUTA}</td>
                                        <td className='text-end'>${NumberFormat(pricesFormat(order.NonTaxableSalesAmt))}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot className='tfoot'>
                                <tr>
                                    <td className='textTableSize fw-bold'>Total</td><td colSpan={4}></td>
                                    <td className='textTableSize text-end fw-bold'>${NumberFormat(pricesFormat(this.state.Total))}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </DashModalV2>

            </>
        )
    }
}
